'use strict';

var LdJsonTools = {};

/**
 * Takes a json object and evaluates instances of {{...}}, and then appends a ld+json object to the document.
 * Example:
	{
		"description" : "{{documentQuerySelectorAll(.jobPostingLdJsonDescription)}}"
	}
 * @param {object} jsonData 
 */
LdJsonTools.create = function(jsonData) {
	var content = JSON.stringify(jsonData);
	var newContent = content.replace(/\{\{\s*([^(]+)\(\s*([^)\s]+)\s*\)\s*\}\}/g, templateFunctionReplacer);

	var jsonElement = document.createElement('script');
	jsonElement.type = "application/ld+json";
	jsonElement.textContent = newContent;
	document.body.appendChild(jsonElement);
}

function templateFunctionReplacer(match, funcName, funcArgString, offset, str) {
	if (funcName === "documentQuerySelectorAll") {
		return documentQuerySelectorAll(funcArgString);
	}
	return "";
}

function documentQuerySelectorAll(selector) {
	var r = "";
	var elems = document.querySelectorAll(selector);
	for (var i = 0, len = elems.length; i < len; i++) {
		r += encodeHtmlEntities(elems[i].innerHTML);
	}
	return r;
}

function encodeHtmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

module.exports = LdJsonTools;

